import React from 'react';
import DoctorIcon from 'src/Admin/img/persona-framework/doctor-icon.svg';

const Lists = ({
  data,
  dataObject,
  selectChangeHandler,
  searchString,
  selectedDoctorIds,
  isLoading,
}) => {
  const onChangeHandler = (e, docData) => {
    selectChangeHandler(e, docData);
  };

  return (
    <div className="blob-lists blob-lists-height">
      {
        <>
          {data.length
            ? data.map((doc, index) => {
                const item = dataObject[doc];
                return dataObject[doc] ? (
                  <div key={index}>
                    <div className="blob-list-item-border">
                      <div className="d-flex broker-list-item doctor-list-item">
                        <div className="d-flex">
                          <div className="d-flex m-auto margin-right-8">
                            <input
                              type="checkbox"
                              id={item.ConnectorID}
                              name={item.ConnectorID}
                              className="p-0 mt-auto mb-auto mr-0 doc-select-chkbox"
                              onChange={(e) => onChangeHandler(e, item)}
                              checked={selectedDoctorIds.includes(
                                item.ConnectorID,
                              )}
                              //value={item.ConnectorID}
                            />
                          </div>
                          <div className="doc-icon m-auto margin-right-8">
                            <img src={DoctorIcon} alt="doc icon" />
                          </div>
                          <div className="m-auto">
                            <div>
                              <span className="blob-item-name-1">{`${item.LastName}, ${item.FirstName} ${item.MiddleName}`}</span>
                            </div>
                            <div className="blob-item-desc-1">
                              {item.Specialty}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="blob-item-desc-2">
                            {/*NPI: {item.npi}*/}
                            {item.NationalProviderId
                              ? `NPI: ${item.NationalProviderId}`
                              : null}
                          </div>
                          {
                            <div className="blob-item-desc-3">
                              {/*Tax ID: {item.taxId}*/}
                              {item.TaxID ? `Tax ID: ${item.TaxID}` : null}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null;
              })
            : null}
        </>
      }
    </div>
  );
};

export default Lists;
